/* eslint-disable */
var validator = {
  // cn:/^[\u4e00-\u9fa5]*$,
  // phone:/^1[3|5][0-9]\d{4,8}$/,
  tele: {
    pattern: /^(0[0-9]{2,3}\-)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/,
    msg: '请输入正确的联系电话 格式：0410-0000000 或 024-00000000'
  },

  phone: {
    pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,///^1[3|4|5|6|7|8|9][0-9]\d{4,11}$/,
    msg: '请输入正确的手机号'
  },
  phoneTele: {
    pattern: /(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}/,
    msg: '请输入正确的11位手机号或固定电话(区号3到4-号码7到8)'
  },
  cn: {
    pattern: /^[\u4e00-\u9fa5]*$/,
    msg: '请输入汉字'
  },
  ennum: {
    pattern: /^[A-Za-z0-9]+$/,
    msg: '请输入英文或者数字'
  },
  cnen: {
    pattern: /^([A-Za-z]|[\u4E00-\u9FA5])+$/,
    msg: '请输入英文或者汉字'
  },
  parentheses: {
    pattern: /(?=.*\(.*\)|.*（.*）)^[a-zA-Z0-9\u4e00-\u9fa5()（）]*$|^[a-zA-Z0-9\u4e00-\u9fa5]*$/,
    msg: '请输入英文或者汉字'
  },
  numTow: {
    // pattern: /^\d+$|^\d*\.\d+$/g,
    pattern: /^ [-] ? [0 - 9] *\.? [0 - 9] + (eE ? [0 - 9] +) ? $/,
    msg: '请输入英文或者汉字'
  },
  cnennum: {
    pattern: /^([A-Za-z0-9]|[\u4E00-\u9FA5])+$/,
    msg: '请输入英文、数字、汉字'
  },
  zeronumber: {
    pattern: /^\d+$/,
    msg: '请输入非负整数'
  },
  znumber: {
    pattern: /^[1-9]\d*$/,
    msg: '请输入正整数'
  },
  number: {
    pattern: /^-?[1-9]\d*$/,
    msg: '请输入整数'
  },
  postNum: {
    pattern: /\d{6}/,
    msg: '请输入6位数字'
  },
  price: {
    // pattern: /^\d+(\.\d{1,3})?$/,
    // pattern: /^((\d+\.\d*[1-9]\d{-1})|(\d*[1-9]\d*\.\d{2}))$/,
    pattern: /^([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])$/,
    msg: '请输入正确的数（保留小数点后三位）'
  },
  num: {
    // pattern: /^\d+(\.\d{1,3})?$/,
    // pattern: /^((\d+\.\d*[1-9]\d{-1})|(\d*[1-9]\d*\.\d{2}))$/,
    pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,3})))$/,
    msg: '请输入正确的数（保留小数点后两位）'
  },
  sale: {
    pattern: /^\d+(\.\d{1,1})?$/,
    msg: '请输入正确的数（保留小数点后一位）'
  },
  contactsPhone: {
    pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
    msg: '请输入有效电话号'
  },
  identityCode: {
    pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
    msg: '请输入有效身份证号'
  }
}
if (module) module.exports = validator
// export default validator
